import script from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyNewProxy.vue?vue&type=script&setup=true&lang=js"

import "./BuyNewProxy.vue?vue&type=style&index=0&id=c05d3ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c05d3ec8"]])

export default __exports__